import { useTranslations } from '@/lib/next-shim'

import { DocumentsSection } from '@/features/documents'

import { Consultations } from './Consultations'
import { DefaultMeetingLinks } from './DefaultMeetingLinks'
import { Expertises } from './Expertises'
import { Orders } from './Orders'

export function DashboardSkeleton() {
  const t = useTranslations('page.AccountDashboard')
  return (
    <div className="flex flex-1 flex-col">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 pt-6 pb-20 sm:gap-10">
        <div className="mx-5 h-40 animate-pulse rounded-2xl bg-gradient-to-br from-primary/80 to-[#015066]/80 sm:h-44" />
        <DefaultMeetingLinks isLoading />
        <Orders orders={[]} />
        <Consultations consultations={[]} />
        <Expertises expertises={[]} />
        <DocumentsSection files={[]} title={t('documents.title')} showUploadButton objectType="patient" objectId="" />
      </div>
    </div>
  )
}
